import { Item } from '@factorialco/deprecated-design-system'
import { A3innuvaCostCentersFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { MappingTable } from 'modules/payroll_integrations_a3innuva/components/SettingsSteps/CodeFillers/MappingTable'
import { A3InnuvaMapping } from 'modules/payroll_integrations_a3innuva/lib/types'

interface CostCenterItemProps {
  costCenters: A3innuvaCostCentersFragment[]
  mappings: A3InnuvaMapping[]
  options: Item[]
  onMappingChanged: (mappings: A3InnuvaMapping[]) => void
  loading: boolean
}

export const CostCenterItem = ({
  costCenters,
  mappings,
  options,
  onMappingChanged,
  loading,
}: CostCenterItemProps) => {
  const createMapping = (
    factorialCostCenterId: string,
    a3CostCenterId: string
  ): A3InnuvaMapping => {
    return {
      factorial_id: factorialCostCenterId,
      a3innuva_id: a3CostCenterId,
    }
  }

  const setFormValues = (selectedItem: Item, costCenter: A3innuvaCostCentersFragment) => {
    const factorialCostCenterId = costCenter.code.toString()
    const a3CostCenterId = selectedItem.value.toString()
    let newMappings: A3InnuvaMapping[] = []

    newMappings = mappings.reduce((filteredMappings, mapping) => {
      const newMapping = { ...mapping }
      if (newMapping.factorial_id !== factorialCostCenterId) {
        filteredMappings.push(newMapping)
        return filteredMappings
      }

      if (selectedItem.value === '') return filteredMappings

      newMapping.a3innuva_id = a3CostCenterId
      return filteredMappings
    }, newMappings)

    newMappings.push(createMapping(factorialCostCenterId, a3CostCenterId))

    onMappingChanged(newMappings)
  }

  const findSelection = (costCenterId: string) => {
    const currentMapping = mappings.find((mapping) => mapping.factorial_id === costCenterId)
    if (!currentMapping) return ''
    const selectedOption = options.find((option) => option.value === currentMapping.a3innuva_id)
    return selectedOption?.label || ''
  }

  return (
    <MappingTable
      title={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.mapping_table.a3innuva_fields'
      )}
      items={costCenters}
      options={options}
      getItemId={(item) => item.code.toString()}
      getItemLabel={(item) => item.name}
      onSelect={setFormValues}
      findSelection={findSelection}
      selectPlaceholder={i18n.t(
        'app_store_v2.app_integrations.payroll_integrations_a3innuva.settings.steps.cost_center.select'
      )}
      loading={loading}
    />
  )
}
